import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import RequestDemoPage from './pages/RequestDemoPage';
import ThankYouPage from './pages/ThankYouPage';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    // <Router>
    //   <div className="min-h-screen">
    //     <Header />
    //     <Routes>
    //       <Route path="/" element={<HomePage />} />
    //       <Route path="/request-demo" element={<RequestDemoPage />} />
    //       <Route path="/thank-you" element={<ThankYouPage />} />
    //     </Routes>
    //     <Footer />
    //   </div>
    // </Router>
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/request-demo" element={<RequestDemoPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;